import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute } from '@nuxtjs/composition-api'
import {
  useDeleteImpactSolutionMutation,
  useGetImpactGoalQuery,
  useUpsertImpactSolutionMutation,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionsList',
  props: {
    disabled: { type: Boolean, default: false },
    value: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { disabled: boolean, value: any };



const route = useRoute()
const ventureId = computed(() => route.params.venture)
const impactId = computed(() => parseInt(route.params.impact as string, 10))

const { result: impactGoalResult, refetch } = useGetImpactGoalQuery({
  ventureId: ventureId.value,
})
const impactGoal = computed(() => impactGoalResult?.value?.getImpactGoal)
const impact = computed(
  () =>
    impactGoal.value?.impacts?.find((e: any) => e.id === impactId.value) || {
      id: null,
    },
)
const impactSolutions = computed(() => impact.value?.impactSolutions || [])

const { mutate: deleteImpactSolution, onDone: onDeleteDone } =
  useDeleteImpactSolutionMutation()
onDeleteDone(() => {
  refetch()
})

const {
  mutate: upsertImpactSolutionMutation,
  onDone: onUpsertImpactSolutionDone,
} = useUpsertImpactSolutionMutation()
onUpsertImpactSolutionDone(() => {
  refetch()
})

const handleDeleteImpactSolution = (id: number) => {
  if (props.disabled) return
  deleteImpactSolution({ id })
}

const upsertImpactSolution = (fields: any) => {
  if (!impact.value?.id || props.disabled) {
    return
  }
  upsertImpactSolutionMutation({
    input: {
      ventureId: ventureId.value,
      impactId: impact.value?.id,
      ...fields,
    },
  })
}

return { __sfc: true,props, route, ventureId, impactId, impactGoalResult, refetch, impactGoal, impact, impactSolutions, deleteImpactSolution, onDeleteDone, upsertImpactSolutionMutation, onUpsertImpactSolutionDone, handleDeleteImpactSolution, upsertImpactSolution }
}

})